





















import {Component} from "vue-property-decorator";
import BaseDialog from "@/component/Dialog/base-dialog.vue";

@Component({})
export default class EditDialog extends BaseDialog {
  defaultConfirmBtncfg = {
    type: 'primary',
    text: this.$translate('edit'),
    show: true,
  }
}
